import { Component } from '@angular/core'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeCardHeaderSkeletonComponent } from 'se-fe-card/skeleton'
import { SeFeGridModule } from 'se-fe-grid'
import { SeFeLabelValuePairSkeletonComponent } from 'se-fe-label-value-pair/skeleton'
import { SeFeSkeletonModule } from 'se-fe-skeleton'

@Component({
  selector: 'se-po-profile-medical-info-skeleton',
  standalone: true,
  imports: [SeFeCardModule, SeFeCardHeaderSkeletonComponent, SeFeGridModule, SeFeLabelValuePairSkeletonComponent, SeFeSkeletonModule],
  template: `
    <se-fe-card>
      <se-fe-card-header-skeleton seFeDataSize="section" [seFeDataHeavyBorder]="true" [seFeDataTitle]="true"></se-fe-card-header-skeleton>
      <se-fe-card-content [seFeDataDivider]="true">
        <se-fe-grid seFeGridOpts="snug">
          <se-fe-grid-cell seFeGridOpts="1/1 1/2@desktop"><se-fe-label-value-pair-skeleton></se-fe-label-value-pair-skeleton></se-fe-grid-cell>
          <se-fe-grid-cell seFeGridOpts="1/1 1/2@desktop"><se-fe-label-value-pair-skeleton></se-fe-label-value-pair-skeleton></se-fe-grid-cell>
          <se-fe-grid-cell seFeGridOpts="1/1">
            <se-fe-label-value-pair-skeleton seFeDataValue="text|long"></se-fe-label-value-pair-skeleton>
          </se-fe-grid-cell>
        </se-fe-grid>
      </se-fe-card-content>
    </se-fe-card>
  `,
})
export class ProfileMedicalInfoSkeletonComponent {}
